export default function getEmployeeCollection() {
  return $dt?.clcEmployee?.toJSON() || [];
}
